import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Form, Button, CloseButton } from '@deere/ux.uxframe-react';
import { showTierModal } from '../redux/action/modalAction';
import { useHistory } from 'react-router';
import { updateSurveyAnswers } from '../redux/action/surveyAction';
import { useTranslation } from "react-i18next";
import { handleSaveOrUpdate } from '../utils/saveSurveyUtils'
import { useOktaAuth } from '@okta/okta-react'
import { DebounceInput } from 'react-debounce-input';
import store from '../redux/store'

export const TierModal = ({ survey, question, updatedByName, supplierName }) => {

    const showModal = useSelector(state => state.survey.tierShowModal)
    const [answer, setAnswer] = useState(undefined)
    const history = useHistory()
    const dispatch = useDispatch()
    const { t } = useTranslation();
    const { authState } = useOktaAuth();
    const surveyResponse = useSelector(state => state.survey.surveyResponse)
    const userInfo = useSelector(state => state.survey.userInfo)
    const surveyAnswers = [...useSelector(state => state.survey.surveyAnswers)]
    const campaign = store.getState().campaign.campaignAssigned;

    const handleClose = () => {
        dispatch(showTierModal(false))
    }

    const handleOnSave = (e) => {
        if (answer) {
            handleSaveOrUpdate(surveyResponse, surveyAnswers, campaign, userInfo, authState, dispatch, t('lbl_success_save_message'));
            dispatch(showTierModal(false))
            history.push({
                pathname: "/review",
                state: {
                    previous: '/scbm',
                    survey: survey,
                    updatedByName: updatedByName,
                    supplierName: supplierName,
                    surveyType: survey.description,
                    endDate: survey.endDate?survey.endDate:''
                }
            });
        }
    }

    const handleOnChange = (e) => {
        const text = e.target.value
        setAnswer(text)
        dispatch(updateSurveyAnswers({ questionId: question.id, answer: text }));
    }

    return (
        <Modal show={showModal} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title>{t('lbl_ph_t2_reason_header')}</Modal.Title>
                <CloseButton onClick={handleClose} />
            </Modal.Header>
            <Modal.Body className="overflow-hidden">
                <Form.Group>
                    <Form.Label style={{ fontWeight: 'bold' }}>
                        {t('lbl_ph_t2_reason_required')}
                        <span aria-label="required field" className="uxf-is-required">
                            *
                        </span>
                    </Form.Label>
                    <DebounceInput
                        name="reason"
                        element="textarea"
                        className="form-control"
                        size="lg"
                        rows={5}
                        placeholder={t('lbl_ph_t2_reason')}
                        onChange={handleOnChange}
                        debounceTimeout={300} />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={handleClose}
                >
                    {t('btn_close')}
                </Button>
                <Button
                    value={t('btn_save_survey')}
                    type="submit"
                    variant="primary"
                    onClick={handleOnSave}
                >
                    {t('btn_save_survey')}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
